// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__26mLb","title":"BackImages_title__1d80_","images":"BackImages_images__ZqEGL"};